const positionArray = ['left', 'right', 'bottom_left_above', 'bottom_left_below', 'top_left_above', 'top_left_below', 'top_left_middle', 'top_right_above', 'top_right_below', 'top_right_middle'];
const colorValues = {
  blue: {
    ribbon: '#0049ac',
    shadow: '#012169'
  },
  red: {
    ribbon: '#e31837',
    shadow: '#a50e28'
  }
};

/**
 * barker
 * @description Renders the ribbon thing near the cards
 * @param {String} text barker text
 * @param {String} barkerPosition barker position
 * @param {Object} cardData optional campaign object
 * @param {String} barkerColor either the blue or red barker
 * @return {String} barker svg string
 */
function createBarkerSvg(text, barkerPosition = 'left', cardData = null, barkerColor) {
  const {
    hasBarkerAnimation
  } = spaParams.siteParams;
  const position = barkerPosition.toLowerCase();
  const color = barkerColor ? barkerColor.toLowerCase() : 'blue';
  if (positionArray.indexOf(position) === -1) {
    console.error(`Incorrect barkerPosition value '${position}' provided. Must be one of '${positionArray.join("', '")}'.`);
  }
  const textStyles = `
    background:${colorValues[color].ribbon};
    text-decoration: none;
    color: white;
    padding: 0 10px;
    position: absolute;
    top:0;
    font-size:12px;
    font-family:'cnx-regular', Arial, Helvetica, sans-serif;
    white-space: nowrap;`;
  let barker = '';
  const barkerTextClass = `barker--text ${hasBarkerAnimation ? 'barker--animation' : ''}`;
  if (position.indexOf('_left') > -1) {
    barker = `
    <div class="barker ${position}">
      <div class="${barkerTextClass}" style="${textStyles} left:0":>${text}</div>
      <svg xmlns="http://www.w3.org/2000/svg" width="5" height="29" preserveAspectRatio="xMinYMin meet">
        <polygon points="0 24 5 24 5 29" style="fill:${colorValues[color].shadow}"/>
      </svg>
    </div>`;
  } else if (position.indexOf('_right') > -1) {
    barker = `
    <div class="barker ${position}">
      <div class="${barkerTextClass}" style="${textStyles} right:0":>${text}</div>
      <svg xmlns="http://www.w3.org/2000/svg" width="5" height="29" preserveAspectRatio="xMinYMin meet">
        <polygon points="0 24 5 24 0 29" style="fill:${colorValues[color].shadow}"/>
      </svg>
    </div>`;
  } else {
    barker = `
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 110 26" width="110" height="26" preserveAspectRatio="xMinYMin meet" class="barker ${position}">
      <polygon points="0.559 21.134 109.441 21.121 88.566 0.259 21.469 0.224 0.559 21.134" style="fill:${colorValues[color].ribbon}" />
      <polygon points="109.387 21.121 100.362 21.122 104.766 25.713 109.387 21.121" style="fill:${colorValues[color].shadow}" />
      <polygon points="9.412 21.133 0.559 21.134 4.968 25.564 9.412 21.133" style="fill:${colorValues[color].shadow}" />
      <text style="font-size:12px;fill:#fff;font-family:'cnx-regular', Arial, Helvetica, sans-serif;" text-anchor="middle" x="55" y="14">
        ${text}
      </text>
    </svg>`;
  }
  return barker;
}

export { createBarkerSvg as default };
